/*
 * Laboratoire dédié — constantes et petits composants partagés entre les
 * modules de frontend/src/lab/*.js et frontend/src/pages/LaboDashboard.js.
 *
 * Reconstruction du système labo (voir le plan de reconstruction, Phase 7) :
 * ce fichier ne dépend d'AUCUN code de frontend/src/pages/HopitalDashboard.js
 * (qui n'exporte rien d'utilisable) — il duplique volontairement les quelques
 * fragments nécessaires (StatCard, Row, ageFrom, fmtDate) plutôt que de créer
 * une dépendance risquée vers le fichier hôpital. Voir le principe directeur
 * du plan : accepter une duplication de code en échange d'un risque de
 * régression nul sur le tableau de bord hôpital existant.
 */
export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Correctif B7 (déjà appliqué côté hôpital) : la session est portée par le
// cookie httpOnly, plus par un jeton lisible en JavaScript.
export const getAuthConfig = () => ({
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Pour les uploads multipart : NE PAS forcer Content-Type (le navigateur
// pose lui-même la boundary), sinon le fichier est rejeté (422).
export const getUploadConfig = () => ({ withCredentials: true });

// Les rôles labo (cahier des charges, §3.3-3.6) ont déjà leur vrai nom dès la
// base — contrairement au dashboard hôpital, pas besoin de deviner depuis un
// rôle hospitalier réutilisé (voir LAB_ROLE_LABELS de HopitalDashboard.js,
// qui n'a plus lieu d'être ici).
export const LAB_ROLE_LABELS = {
  responsable_labo: "Responsable de laboratoire",
  secretaire: "Secrétaire / Accueil",
  preleveur: "Préleveur",
  biologiste: "Biologiste",
};
export const labRoleLabel = (role) => LAB_ROLE_LABELS[role] || role;

export function StatCard({ label, value, sub, color, accent }) {
  return (
    <div style={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, padding: "16px 18px", borderLeft: `4px solid ${accent || "#185FA5"}` }}>
      <div style={{ fontSize: 28, fontWeight: 700, color: color || "#0F172A", lineHeight: 1.1 }}>{value}</div>
      <div style={{ fontSize: 13, color: "#475569", marginTop: 4 }}>{label}</div>
      {sub != null && <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

export function Row({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #F1F5F9" }}>
      <span style={{ fontSize: 13, color: "#64748B" }}>{label}</span>
      <span style={{ fontSize: 14, color: "#0F172A", fontWeight: 500 }}>{value || "—"}</span>
    </div>
  );
}

export function ageFrom(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d)) return null;
  const diff = Date.now() - d.getTime();
  return Math.floor(diff / (365.25 * 24 * 3600 * 1000));
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleDateString("fr-FR");
}
